import {ProcessKind, ProcessKindCount, PROCESS_COPY} from "./process-ui";
import {ProcessKindIcon} from "./ProcessKindIcon";

export type ProcessKindFilterValue = ProcessKind | "all";

export type ProcessKindFilterProps = {
  /** The kinds in the list, from {@link countProcessKinds}. */
  kinds: ProcessKindCount[];
  /** Everything in the list, for the "All" count. */
  total: number;
  value: ProcessKindFilterValue;
  onChange: (value: ProcessKindFilterValue) => void;
  className?: string;
};

const chip = (selected: boolean) => [
  "inline-flex h-6 shrink-0 items-center gap-1 rounded-full border px-2 text-xs font-medium transition-colors",
  "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-[var(--ots-primary)]",
  selected
    ? "border-transparent bg-[var(--ots-primary-container)] text-[var(--ots-on-primary-container)]"
    : "border-[var(--ots-outline-variant)] text-[var(--ots-text-muted)] hover:bg-[var(--ots-neutral-container)] hover:text-[var(--ots-text)]",
].join(" ");

/** Narrows the tray to one sort of process: reports, merges, data actions, imports or exports. */
export const ProcessKindFilter = ({kinds, total, value, onChange, className}: ProcessKindFilterProps) => {
  const options: {value: ProcessKindFilterValue; label: string; count: number; kind?: ProcessKind}[] = [
    {value: "all", label: PROCESS_COPY.allKinds, count: total},
    ...kinds.map((info) => ({value: info.kind, label: info.pluralLabel, count: info.count, kind: info.kind})),
  ];

  return <div
    role="radiogroup"
    aria-label="Show"
    className={["flex items-center gap-1.5 overflow-x-auto", className].filter(Boolean).join(" ")}>
    {options.map((option) => {
      const selected = option.value === value;
      return <button
        key={option.value}
        type="button"
        role="radio"
        aria-checked={selected}
        aria-label={`${option.label} (${option.count})`}
        onClick={() => onChange(option.value)}
        className={chip(selected)}>
        {option.kind && <ProcessKindIcon kind={option.kind} variant="inline" decorative/>}
        <span>{option.label}</span>
        <span className="tabular-nums opacity-70">{option.count}</span>
      </button>;
    })}
  </div>;
};
